import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  ReturnListReq,
  ReturnListRes,
  CreateReturnReq,
  UpdateReturnReq,
  DeleteReturnReq,
  ReturnDetailReq,
  ActionRes,
  ReturnDetailRes,
} from './types'

export const getReturnListAction = createAsyncAction(
  'RETURN/GET_RETURN_LIST_REQ',
  'RETURN/GET_RETURN_LIST_SUCCESS',
  'RETURN/GET_RETURN_LIST_FAILURE',
)<ReturnListReq, ReturnListRes, Error>()

export const getReturnDetailAction = createAsyncAction(
  'RETURN/GET_RETURN_DETAIL_REQ',
  'RETURN/GET_RETURN_DETAIL_SUCCESS',
  'RETURN/GET_RETURN_DETAIL_FAILURE',
)<ReturnDetailReq, ReturnDetailRes, Error>()

export const createReturnAction = createAsyncAction(
  'RETURN/CREATE_RETURN_REQ',
  'RETURN/CREATE_RETURN_SUCCESS',
  'RETURN/CREATE_RETURN_FAILURE',
)<CreateReturnReq, ActionRes, Error>()

export const updateReturnAction = createAsyncAction(
  'RETURN/UPDATE_RETURN_REQ',
  'RETURN/UPDATE_RETURN_SUCCESS',
  'RETURN/UPDATE_RETURN_FAILURE',
)<UpdateReturnReq, ActionRes, Error>()

export const deleteReturnAction = createAsyncAction(
  'RETURN/DELETE_RETURN_REQ',
  'RETURN/DELETE_RETURN_SUCCESS',
  'RETURN/DELETE_RETURN_FAILURE',
)<DeleteReturnReq, ActionRes, Error>()

export const clearEventAction = createStandardAction('RETURN/CLEAR_EVENT')<void>()
